import {
  CREATE_RELAY_CONTROLLER_STATUS,
  DELETE_RELAY_CONTROLLER_STATUS,
  EDIT_RELAY_CONTROLLER_STATUS,
  RECEIVE_RELAY_CONTROLLER_STATUSES,
  REQUEST_RELAY_CONTROLLER_STATUS,
  REQUEST_RELAY_CONTROLLER_STATUS_FOR_UNIT,
} from '@sophocles/entities/RelayControllerStatus/relayControllerStatusActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_RELAY_CONTROLLER_STATUSES: // Read
      return state.merge(action.relayControllerStatuses);
    case DELETE_RELAY_CONTROLLER_STATUS: // Delete
      return state.delete(action.relayControllerStatus.toString());
    case EDIT_RELAY_CONTROLLER_STATUS: // Update
    case CREATE_RELAY_CONTROLLER_STATUS: // Create
    case REQUEST_RELAY_CONTROLLER_STATUS:
    case REQUEST_RELAY_CONTROLLER_STATUS_FOR_UNIT:
    default:
      return state;
  }
}

export function relayControllerStatusReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_RELAY_CONTROLLER_STATUS:
    case DELETE_RELAY_CONTROLLER_STATUS:
    case RECEIVE_RELAY_CONTROLLER_STATUSES:
    case EDIT_RELAY_CONTROLLER_STATUS:
    case REQUEST_RELAY_CONTROLLER_STATUS:
    case REQUEST_RELAY_CONTROLLER_STATUS_FOR_UNIT:
      return getState(state, action);
    default:
      return state;
  }
}
